import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AdminCase } from "../models";
import { WriteResource } from "../types";
import { RootState } from "../store";
import { archiveCaseApi } from "../api";

export interface ArchiveCaseForm {
  readonly case: AdminCase;
  readonly reasonForChange: string | null;
}

export type ArchiveCaseDialogState =
  | {
      readonly isOpen: true;
      readonly case: WriteResource<ArchiveCaseForm, AdminCase>;
    }
  | {
      readonly isOpen: false;
    };

// thunks
export const caseArchive = createAsyncThunk(
  "archiveCaseDialog/caseArchive",
  async (_: void, thunkApi) => {
    const { getState } = thunkApi;
    const rootState = getState() as RootState;
    const state = rootState.archiveCaseDialog;

    if (state.isOpen) {
      await archiveCaseApi(state.case.data.case.id, state.case.data.reasonForChange || "");
    }
  }
);

export const archiveCaseDialogSlice = createSlice({
  name: "archiveCaseDialog",
  initialState: { isOpen: false } as ArchiveCaseDialogState,
  reducers: {
    openArchiveCaseDialog: (state, action) => {
      return {
        isOpen: true,
        case: {
          data: {
            case: action.payload,
            reasonForChange: null
          }
        }
      };
    },
    closeArchiveCaseDialog: state => {
      state.isOpen = false;
    },
    setArchiveCaseForm: (state, action) => {
      if (state.isOpen) {
        state.case = {
          data: action.payload
        };
      }
    }
  },
  extraReducers: builder => {
    builder.addCase(caseArchive.fulfilled, () => {
      return { isOpen: false } as ArchiveCaseDialogState;
    });
    builder.addCase(caseArchive.rejected, (state, action) => {
      if (state.isOpen) {
        state.case = {
          data: state.case.data,
          errorMessage: action.error.message
        };
      }
    });
  }
});

export const {
  openArchiveCaseDialog,
  closeArchiveCaseDialog,
  setArchiveCaseForm
} = archiveCaseDialogSlice.actions;
export default archiveCaseDialogSlice.reducer;
